import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useWorkspace } from '../../context/WorkspaceContext';
import avatarImg from '../../images/Job_avatar.webp';
import FontScalePicker from '../FontScalePicker';

export default function WorkspaceHeader({ voiceStatus, isSpeaking, hasUserSpoken, onOpenReview, onReset, onOpenPreferences, onOpenTour }) {
  const { state } = useWorkspace();
  const [showHelp, setShowHelp] = useState(false);
  const isVoiceConnected = voiceStatus === 'connected';

  // AIVD matcher: show conversation length instead of vacancy section completion
  const userTurns = state.conversation.messages.filter(m => m.sender === 'user').length;
  const matcherStatus = isVoiceConnected
    ? (isSpeaking ? 'Spreekt…' : hasUserSpoken ? 'Luistert mee' : 'Begin met praten')
    : userTurns > 0
      ? `${userTurns} ${userTurns === 1 ? 'bericht' : 'berichten'} verzonden`
      : 'Standby — start het gesprek';

  const avatarState = isSpeaking
    ? 'ws-header__avatar-wrap--speaking'
    : isVoiceConnected
      ? 'ws-header__avatar-wrap--listening'
      : '';

  return (
    <header className="ws-header">
      <div className="ws-header__bg-pattern" aria-hidden="true" />

      {/* Left: Brand */}
      <Link to="/" className="ws-header__brand" aria-label="Terug naar home">
        <div className="ws-header__brand-text ws-header__brand-text--matcher">
          <span className="ws-header__brand-hai">HUMANAIZE</span>
          <span className="ws-header__brand-job">Matcher</span>
        </div>
      </Link>

      {/* Center: Avatar + matcher status (no vacancy progress) */}
      <div className="ws-header__hero-center">
        <div className={`ws-header__avatar-wrap ${avatarState}`}>
          <span className="ws-header__ring ws-header__ring--1" />
          <span className="ws-header__ring ws-header__ring--2" />
          <span className="ws-header__ring ws-header__ring--3" />
          <img
            className="ws-header__avatar"
            src={avatarImg}
            alt="Matcher"
          />
        </div>
        <div className="ws-header__hero-info">
          <div className="ws-header__progress-info">
            <span className="ws-header__step-label">Talent matching</span>
          </div>
          <div className="ws-header__live-badge">
            <span className="ws-header__live-dot" />
            {matcherStatus}
          </div>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="ws-header__right">
        {false && onOpenReview && (
          <button
            type="button"
            className="ws-header__review-btn"
            onClick={onOpenReview}
          >
            <span className="material-icons">rate_review</span>
            <span className="ws-header__review-label">Bekijk resultaat</span>
          </button>
        )}
        {state.ui.hasStarted && onReset && (
          <button
            type="button"
            className="ws-header__action"
            onClick={onReset}
            aria-label="Begin opnieuw"
            title="Begin opnieuw"
          >
            <span className="material-icons">restart_alt</span>
          </button>
        )}
        <button
          type="button"
          className="ws-header__action"
          onClick={() => setShowHelp(v => !v)}
          aria-label="Hoe werkt de matcher?"
          title="Hoe werkt de matcher?"
        >
          <span className="material-icons">help_outline</span>
        </button>
        <FontScalePicker className="ws-header__font-picker" />
      </div>

      {showHelp && (
        <div className="ws-help-popover" onClick={() => setShowHelp(false)}>
          <div className="ws-help-popover__card" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="ws-help-popover__close"
              onClick={() => setShowHelp(false)}
              aria-label="Sluiten"
            >
              <span className="material-icons">close</span>
            </button>
            <h3>Hoe werkt de matcher?</h3>
            <ol>
              <li>
                <strong>Vertel je vraag.</strong> Klik op de microfoon om te praten,
                of typ direct in het chatvenster waar je iemand voor zoekt.
              </li>
              <li>
                <strong>De intaker stelt vragen.</strong> Eén tegelijk — over het type
                opdracht, het domein, skills, soft skills en tijdspad.
              </li>
              <li>
                <strong>Live matching.</strong> Naast het gesprek verschijnen de
                top-3 best passende student-engineers met hun signature abilities en
                waarom ze passen, gekoppeld aan wat je net zei.
              </li>
              <li>
                <strong>Bekijk het dossier.</strong> Klik op een kaart voor het
                volledige personnel dossier (specialisaties, projecten, ervaring).
              </li>
            </ol>
            <p className="ws-help-popover__footnote">
              Privacy: gesprekken worden niet opgeslagen. Sluit het tabblad en alles
              is weg.
            </p>
          </div>
        </div>
      )}
    </header>
  );
}
